
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-ai/choose-picture",
      function () {
        return require("private-next-pages/create-ai/choose-picture/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-ai/choose-picture"])
      });
    }
  